export const SUMMARY_TYPES = {
	JOB: 'job',
	TASK: 'task',
	EMPLOYEE: 'employee',
}

export const AVAILABLE_JOB_COLUMN_NAMES = [
	'Job Key',
	'Job ID',
	'Job Name',
	'Customer Name',
	'Job Status',
	'Last Update By',
	'Last Update Date/Time',
	'Pending Tasks',
	'In Progress Tasks',
	'Completed Tasks',
]

export const DEFAULT_JOB_COLUMNS = [
	{
		name: 'Job_Key',
		title: 'Job Key',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Job_ID',
		title: 'Job ID',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Job_Name',
		title: 'Job Name',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Customer_Name',
		title: 'Customer Name',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Job_Status',
		title: 'Job Status',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Last_Update_By',
		title: 'Last Update By',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Last_Update_DateTime',
		title: 'Last Update Date/Time',
		type: 'DATETIME',
		format: {},
	},
	{
		name: 'Pending_Tasks',
		title: 'Pending Tasks',
		type: 'STRING',
		format: {},
	},
	{
		name: 'In_Progress_Tasks',
		title: 'In Progress Tasks',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Completed_Tasks',
		title: 'Completed Tasks',
		type: 'STRING',
		format: {},
	},
]

export const DISPLAY_TASK_COLUMNS = [
	'Task_Start_Date',
	'Task_Start_Time',
	'Task_Number',
	'Task_Created_By',
	'Task_Status',
	'Last_Update_By',
	'Last_Update_Date_Time',
	'Customer_Name',
	'Job_Name',
	'Task_Type',
	'Total_Hours',
	'Estimate',
	'Total_Cost',
]

export const DEFAULT_TASK_COLUMNS = [
	{
		name: 'Task_Number',
		title: 'Task Number',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Task_Created_Date_Time',
		title: 'Task Created Date/Time',
		type: 'DATETIME',
		format: {},
	},
	{
		name: 'Task_Created_By',
		title: 'Task Created By',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Task_Status',
		title: 'Task Status',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Last_Update_By',
		title: 'Last Update By',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Last_Update_Date_Time',
		title: 'Last Update Date/Time',
		type: 'DATETIME',
		format: {},
	},
	{
		name: 'Customer_Name',
		title: 'Customer Name',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Job_Name',
		title: 'Job Name',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Task_Type',
		title: 'Task Type',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Total_Hours',
		title: 'Total Hours',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Estimate',
		title: 'Estimate',
		type: 'STRING',
		format: {},
	},
	{
		name: 'Total_Cost',
		title: 'Total Cost',
		type: 'STRING',
		format: {},
	},
]

export const LABEL_FOR_TYPE = {
	job: 'common:misc.summaryJob',
	task: 'common:misc.summaryTask',
}

export const DEFAULT_STATUS_CARDS = {}

export const TASK_MAP_SETTING_TYPES = {
	GRID: 'grid',
	MAP: 'map',
	ALL: 'all',
}
